/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import EventBusService, {
  INSERT_LIQUID_WITH_FALLBACK_MODAL_CLOSE,
  INSERT_LIQUID_WITH_FALLBACK_MODAL_OPEN,
} from 'cio/services/event-bus';

interface LiquidFallbackModalArgs {
  liquid: string;
  insertLiquidWithFallback: (fallback: string) => unknown;
  onClose: (isDontShowAgainChecked: boolean) => unknown;
}

export default class LiquidFallbackModal extends Component<LiquidFallbackModalArgs> {
  @service eventBus!: EventBusService;

  @tracked isFallbackValueSelected = true;
  @tracked fallbackValue = '';
  @tracked isDontShowAgainChecked = false;

  get isAddDisabled() {
    return this.isFallbackValueSelected && this.fallbackValue.trim() === '';
  }

  @action
  insertLiquidWithFallback(event: Event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.args.insertLiquidWithFallback(this.isFallbackValueSelected ? this.fallbackValue : '');
    this.closeModalWithDontShowCheck();
  }

  @action
  triggerOpenEvent() {
    this.eventBus.publish(INSERT_LIQUID_WITH_FALLBACK_MODAL_OPEN);
  }

  /**
   * Triggered when Esc, clicked outside or clicked the cancel button,
   * so don't show again checkbox is ignored.
   */
  @action
  closeModal() {
    this.fallbackValue = '';
    this.eventBus.publish(INSERT_LIQUID_WITH_FALLBACK_MODAL_CLOSE);
    this.args.onClose(false);
  }

  @action
  closeModalWithDontShowCheck() {
    this.fallbackValue = '';
    this.args.onClose(this.isDontShowAgainChecked);
  }
}
